import { Button } from "@/components/ui/baseUi/button"
import { InputGroup, InputGroupAddon, InputGroupInput } from "@/components/ui/baseUi/input-group"
import { useBoxShopSidebar } from "@/modules/boxShop/hooks/useBoxShopSidebar"
import { word } from "@/modules/core/utils/i18n"
import { PlusIcon, SearchIcon, XIcon } from "lucide-react"
import { Suspense, useRef, useState } from "react"
import useDebounce from "@/modules/hooks/useDebounce"
import { BoxShopInventoryDatable } from "@/modules/boxShop/components/boxShopInventoryDatable"
import { LoadingSpinner } from "@/modules/ui/components/loading"
import { useBoxStaffPermission } from "@/modules/boxStaff/hooks/useBoxStaffPermissions"
import { BoxStaffPermissions } from "@/modules/boxStaff/gateway/boxStaffDto"
import type { BoxShopItemFormRef } from "@/modules/boxShop/components/boxShopItemForm"

export function BoxShopInventoryView() {
  const { navigateToBoxShopItemForm } = useBoxShopSidebar()
  const [searchTerm, setSearchTerm] = useState("")
  const searchTermDebounced = useDebounce(searchTerm, 300)
  const canAddItem = useBoxStaffPermission(BoxStaffPermissions.ADD_ITEM)
  const boxShopItemFormRef = useRef<BoxShopItemFormRef>(null)
  const clearSearch = () => {
    setSearchTerm("")
  }

  return (
    <div className="flex flex-1 flex-col">
      <div className="flex flex-row gap-4">
        {/* SEARCH INPUT */}
        <InputGroup className="h-12 max-w-92">
          <InputGroupInput
            placeholder={word("boxShop.item.search.placeholder")}
            onChange={(e) => setSearchTerm(e.currentTarget.value)}
            value={searchTerm}
          />
          <InputGroupAddon align="inline-start">
            <SearchIcon />
          </InputGroupAddon>
          {searchTerm && (
            <InputGroupAddon align="inline-end">
              <XIcon className="size-4 cursor-pointer" onClick={clearSearch} />
            </InputGroupAddon>
          )}
        </InputGroup>

        {canAddItem && (
          <Button
            variant="secondary"
            size="lg"
            onClick={() => {
              void navigateToBoxShopItemForm({
                boxShopItemFormRef,
                args: { replaceAllComponents: true },
                item: undefined,
              })
            }}
          >
            <PlusIcon />
            {word("boxShop.item.text")}
          </Button>
        )}
      </div>
      {/* DATATABLE INVENTORY LIST */}
      <Suspense fallback={<LoadingSpinner />}>
        <BoxShopInventoryDatable searchTerm={searchTermDebounced} />
      </Suspense>
    </div>
  )
}
